import { ca } from '@cian/analytics';

import { INewReviewsSecondStepOpen } from '../../types/newReview/analytics';
import { TUserAnalytics } from '../../types/currentUser';

export const trackOpenNewReviewSecondStep = ({
  siteType,
  rating,
  ratings,
  user,
}: {
  siteType: string;
  rating: number;
  ratings: INewReviewsSecondStepOpen;
  user: TUserAnalytics;
}) => {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'NewbuildingReviews',
    action: 'Show_sopr',
    label: 'Review_Screen2_Questions',
    useLastProducts: true,
    user,
    page: {
      offerType: 'JK',
      pageType: 'ReviewsJK',
      siteType,
      extra: {
        rating,
        ratings,
      },
    },
  });
};
